// The error boundary uses this once per session when a cached route chunk no
// longer exists in the active deployment.
export const CHUNK_RECOVERY_SESSION_KEY = "chunk-recovery-attempted";
// Only the worker's per-URL navigation copies can pin an old build's HTML to
// chunk hashes that are gone. The precache is the only offline copy of the
// current build, and `static-resources` holds the cached `/__env.js`, so the
// recovery reload needs both to boot offline.
const CHUNK_RECOVERY_CACHE_NAMES = ["inspections-html"];

const CHUNK_LOAD_MESSAGE_PATTERNS = [
  /failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /importing a module script failed/i,
];

export function isChunkLoadError(error: {
  message?: string;
  stack?: string;
}): boolean {
  return CHUNK_LOAD_MESSAGE_PATTERNS.some((pattern) =>
    pattern.test(error.message ?? ""),
  );
}

export async function clearChunkRecoveryCaches(): Promise<void> {
  if (typeof window === "undefined" || !("caches" in window)) {
    return;
  }

  const cacheNames = await window.caches.keys();
  const targets = cacheNames.filter((name) =>
    CHUNK_RECOVERY_CACHE_NAMES.includes(name),
  );
  await Promise.all(targets.map((name) => window.caches.delete(name)));
}
